import React from 'react';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { FormLogin } from '@app/src/common/session';
import { ModalErrorFeature } from '@app/src/common/modalError';

export const Login: React.FC = () => (
  <React.Fragment>
    <HeaderFeature />
    <FormLogin />
    <FooterFeature isDisplay={true} />
    <ModalErrorFeature />
  </React.Fragment>
);
